import { useState } from 'react';
import { Button } from 'src/components/button';
import { ExportSettingsType } from 'src/context/global/types';
import { useGlobalContext } from 'src/context/global/use-global-context';

import { DialogWrapper } from './shared/dialog-wrapper';
import { PaperSizeSelector } from './shared/paper-size-selector';
import { ResolutionSelector } from './shared/resolution-selector';

interface ExportSettingsDialogProps {
  defaultSettings: ExportSettingsType;
}

export default function DialogExportSettings({
  defaultSettings,
}: ExportSettingsDialogProps) {
  const { showDialogs, setShowDialogs, projectData, setProjectData } =
    useGlobalContext();

  const [settings, setSettings] = useState<ExportSettingsType>(defaultSettings);

  const onClose = () => {
    setShowDialogs({ ...showDialogs, exportSettings: false });
  };

  const handleConfirm = () => {
    setProjectData({ ...projectData, exportSettings: settings });
    onClose();
  };

  return (
    <DialogWrapper
      title="Export Settings"
      onClose={onClose}
      testId="dialog-export-settings"
      footer={
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            onClick={onClose}
            data-testid="dialog-export-settings-cancel-button"
            color="gray"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            data-testid="dialog-export-settings-confirm-button"
          >
            Export
          </Button>
        </div>
      }
    >
      <PaperSizeSelector
        selectedSize={settings.paperSize}
        onSelect={(size) => setSettings({ ...settings, paperSize: size })}
      />

      <ResolutionSelector
        selectedResolution={settings.resolution}
        onSelect={(resolution) => setSettings({ ...settings, resolution })}
      />
    </DialogWrapper>
  );
}
